import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_CMS_FREE } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { CMS_SIGNUP_BUSINESS_INTENT } from '../constants/surveyConstants';
import { getAiOnboardingFlowUrl, getAiOnboardingLandingPageUrl, HubletUrl } from '../utils/urls';
import { BLOG_NEW_ONBOARDING_FLOW } from '../constants/gateConstants';
import { CMS_FREE_SIGNUP } from '../constants/signupConstants';
import { ONBU025_EXPERIMENT_KEY, ONBU025_VARIANT_GROUP } from '../constants/experimentConstants';
const cmsExperiencesChecks = [{
  // Note: ONBU025 variant users see the same experience except with the variant groupkeys
  // The only change in these groupkeys is that the 'create contact' and 'create deal' tasks go to the corresponding wizard instead of a tour
  redirectPath: portalId => {
    return {
      url: getAiOnboardingFlowUrl(portalId),
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: FREE_GROUP_KEYS.freeCmsViewCmsSignupWizard
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    searchParams: {
      'ai-onboarding': 'true'
    },
    signupType: CMS_FREE_SIGNUP
  }]
}, {
  redirectPath: portalId => {
    return {
      url: getAiOnboardingFlowUrl(portalId),
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: FREE_GROUP_KEYS.freeCmsViewCmsSignup
    };
  },
  checks: [{
    searchParams: {
      'ai-onboarding': 'true'
    },
    signupType: CMS_FREE_SIGNUP
  }]
}, {
  redirectPath: portalId => {
    return {
      url: getAiOnboardingLandingPageUrl(portalId),
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: FREE_GROUP_KEYS.freeCmsViewCmsSignupWizard
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    signupType: CMS_FREE_SIGNUP,
    survey: {
      cmsSignupIntent: CMS_SIGNUP_BUSINESS_INTENT
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: getAiOnboardingLandingPageUrl(portalId),
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: FREE_GROUP_KEYS.freeCmsViewCmsSignup
    };
  },
  checks: [{
    signupType: CMS_FREE_SIGNUP,
    survey: {
      cmsSignupIntent: CMS_SIGNUP_BUSINESS_INTENT
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: FREE_GROUP_KEYS.freeCmsViewCmsSignupWizard
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    signupType: CMS_FREE_SIGNUP
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: FREE_GROUP_KEYS.freeCmsViewCmsSignupV2
    };
  },
  checks: [{
    gates: [BLOG_NEW_ONBOARDING_FLOW],
    signupType: CMS_FREE_SIGNUP
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.CMS,
      onboardingKey: ONBOARDING_CMS_FREE,
      groupKey: FREE_GROUP_KEYS.freeCmsViewCmsSignup
    };
  },
  checks: [{
    signupType: CMS_FREE_SIGNUP
  }]
}];
export default cmsExperiencesChecks;